import React from "react";

const blogs = [
  {
    id: 1,
    image: "images/blog1.jpg",
    tag: "BLOG",
    title: "Ampstek pay Launches a Fresh Brand Identity for Its Global Division",
    description: "Ampstek pay has launched a refreshed brand identity for its global division, featuring a new logo and modernized design elements. This update reflects the company’s commitment to growth, innovation, and a stronger presence in international markets. The rebranding aims to enhance recognition Ampstek pay’s focus on delivering cutting-edge solutions across various industries.",
  },
  {
    id: 2,
    image: "images/blog2.jpg",
    tag: "BLOG",
    title: "Why You Won’t Come Across an International Umbrella Company",
    description: "An international umbrella company doesn't exist because the concept of umbrella companies is generally tied to specific countries' tax and employment regulations. These companies act as intermediaries for contractors or freelancers, providing services such as payroll and tax administration, but they must comply with local laws. ",
  },
  {
    id: 3,
    image: "images/blog3.jpg",
    tag: "BLOG",
    title: "Understanding the 183-Day Rule",
    description: "The 183-Day Rule is a standard used by many countries to establish tax residency based on the number of days an individual spends within their borders. If a person is physically present in a country for 183 days or more during a tax year, they are generally classified as a tax resident in that country. This designation often carries specific obligations, such as the requirement to report and pay taxes on global income.",
  },
];

const BlogSection = () => {
  return (
    <div className="blog-section">
      <div className="blog-header">
        <h2>Resources to Support Your Global Expansion</h2>
        <p>
        Not quite ready to schedule your free Global Expansion Session? Explore our range of resources to enhance your knowledge first. From global employment insights to international expansion guides, take a look before taking the next step.
        </p>
      </div>
      <div className="blog-cards">
        {blogs.map((blog) => (
          <div className="blog-card" key={blog.id}>
            <img
              src={blog.image}
              alt={blog.title}/>
            <div className="blog-card-content">
              <span >{blog.tag}</span>
              <h3 >{blog.title}</h3>
              <p >{blog.description}</p>
              <button>Read more →</button>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default BlogSection;
